import { jsx as _jsx } from "react/jsx-runtime";
var BoldLock = function BoldLock(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#fff' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size * 0.8,
    height: size,
    viewBox: "0 0 16 20",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 14C7.448 14 7 13.552 7 13C7 12.448 7.448 12 8 12C8.552 12 9 12.448 9 13C9 13.552 8.552 14 8 14ZM8 10C6.346 10 5 11.346 5 13C5 14.654 6.346 16 8 16C9.654 16 11 14.654 11 13C11 11.346 9.654 10 8 10ZM14 17C14 17.552 13.552 18 13 18H3C2.448 18 2 17.552 2 17V9C2 8.448 2.448 8 3 8H4H6H10H12H13C13.552 8 14 8.448 14 9V17ZM6 4.111C6 2.947 6.897 2 8 2C9.103 2 10 2.947 10 4.111V6H6V4.111ZM13 6H12V4.111C12 1.845 10.206 0 8 0C5.794 0 4 1.845 4 4.111V6H3C1.346 6 0 7.346 0 9V17C0 18.654 1.346 20 3 20H13C14.654 20 16 18.654 16 17V9C16 7.346 14.654 6 13 6Z",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default BoldLock;